import React from "react";
import ModalContainer from "../../../../components/ModalContainer";
import {useUpcomingCallModal} from "./useUpcomingCallModal";
import {CheckboxItem, Input, ReactSelect} from "../../../../components/UI";
import {ExtraSelect} from "../../../../components/UI/ExtraSelect/ExtraSelect";
import Loader from "../../../../components/other/Loader";
import {ModalLoader} from "../../../../components/other/ModalLoader/ModalLoader";

type Props = {
    isOpen: boolean;
    closeModal: () => void;
    refresh: () => void;
    id?: number
    hideUpcomingFields?: boolean
    setSuccess: () => void
}

const textStyle: React.CSSProperties = {
    fontFamily: "Inter",
    fontSize: "15px",
    fontWeight: 400,
    textAlign: "center",
    marginTop: "20px"
}

export const UpcomingCallModal: React.FC<Props> = ({ isOpen, closeModal, id, refresh, hideUpcomingFields = false, setSuccess }) => {
    const {
        companies,
        types,
        values,
        setValues,
        changeField,
        projects,
        selectedCategory,
        loading,
        availableCallsItem,
        sum,
        type,
        createNewCall,
        isAvailableCallButton,
        isRemoveLink,
        isLinkError,
        isDateError
    } = useUpcomingCallModal(refresh, hideUpcomingFields, setSuccess)

    return (
        <div className={"follow-up-modal"}>
            <ModalContainer heading={""} isOpen={isOpen} close={closeModal}>
                <div className={"relative"}>
                    {loading && <ModalLoader />}
                    <h3 style={{ margin: "-33px auto 0 auto", width: "max-content" }}>CREATE NEW CALL</h3>
                    <h4>Call Info</h4>
                    <ExtraSelect
                        className={"mt15"} isShowSearch
                        value={values.company_id}
                        options={companies.map(el => ({ value: el.id, label: el.name }))}
                        onClick={changeField}
                        name={"company_id"}
                        tooltip={{ label: "Credits Balance", value: selectedCategory?.total_credit_count || "0" }}
                    />
                    {projects.length > 0 && <ExtraSelect
                        emptyMessage={"Project not selected"}
                        className={"mt15"}
                        value={values.business_goal_id}
                        options={projects.map(el => ({value: el.id + "", label: el.title}))}
                        onClick={changeField}
                        name={"business_goal_id"}
                    />}
                    <ExtraSelect
                        className={"mt15"}
                        value={values.type_id}
                        options={types.map(el => ({ value: el.id + "", label: el.title }))}
                        onClick={changeField}
                        name={"type_id"}
                        tooltip={{ label: "Calls", value: availableCallsItem?.count || "0" }}
                    />
                    <Input
                        label={"Date"}
                        className={"mt15"}
                        otherProps={{
                            type: "datetime-local",
                            placeholder: "Date",
                            value: values.date || 0,
                            onChange: changeField,
                            name: "date",
                        }}
                        errorMessage={"This field is required"}
                        valid={!isDateError}
                    />
                    {!hideUpcomingFields && <Input
                        label={"Link"}
                        className={"mt15"}
                        otherProps={{
                            type: "text",
                            placeholder: "Link",
                            value: values.link,
                            onChange: changeField,
                            name: "link",
                        }}
                        errorMessage={"enter correct url"}
                        valid={!isLinkError}
                    />}
                    <div>
                        <CheckboxItem
                            style={{ alignItems: "center" }}
                            active={!values.is_payment_required}
                            onChange={() => setValues({ ...values, is_payment_required: !values.is_payment_required })}
                            label={"No payment required"}
                        />
                    </div>
                    {values.is_payment_required && <div>
                        {(+(availableCallsItem?.count || 0) === 0 && sum >= 0) && <p style={{...textStyle}}>
                            Total: {type?.credit_price} credit{(type?.credit_price || 0) > 1 && "s"} will be charged
                        </p>}
                        {(+(availableCallsItem?.count || 0) === 0 && sum < 0) &&
                            <p style={{...textStyle, color: "#FF5C5C"}}>
                                The client doesn’t have enough credits.
                            </p>}
                    </div>}
                    {!hideUpcomingFields && <div className={"flex justify-between align-items-center w100 mt20"}>
                        <div className={"w50 mr20"}>
                            <button onClick={() => createNewCall(false)} disabled={!isAvailableCallButton}
                                    className={"btn-black w100"}>ADD A CALL
                            </button>
                        </div>
                        <div className={"w50"}>
                            <button onClick={() => createNewCall(true)} disabled={!isAvailableCallButton}
                                    className={"btn-black w100"}>ADD A CALL & BOOK
                            </button>
                        </div>
                    </div>}
                    {hideUpcomingFields && <div className={"w100 mt20"}>
                        <button onClick={() => createNewCall(false)} disabled={!isAvailableCallButton}
                                className={"btn-black w100"}>ADD A CALL
                        </button>
                    </div>}
                    {isRemoveLink && <p style={{...textStyle, color: "#FF5C5C"}}>
                        Remove a link to book a new call or click on “Add a call”.
                    </p>}
                </div>
            </ModalContainer>
        </div>
    )
}